import { Modal } from "@circle-react-uikit/ModalV2";
import { useModal } from "@circle-react/components/Layout/ModalManagerProvider";
import { usePunditUserContext } from "@circle-react/contexts/punditUserContext";

import { t } from "@/i18n-js/instance";

import { ContactSupport } from "../ContactSupport";
import { Loader } from "../Loader";
import { UpgradeFlow } from "../UpgradeFlow";
import { useUpgradePlanContext } from "../UpgradePlanContext";
import type { UpgradePlanModalComponentProps } from "./UpgradePlanModalWrapper";

const i18nRoot = "pricing_plans.upgrade_modal";

export const UpgradePlanModalUIKitInner = ({
  subheading,
  onSuccess,
  successButtonLabel,
  onCloseModal,
}: UpgradePlanModalComponentProps) => {
  const {
    isPlanLoading,
    isEmailHubPlanLoading,
    errorFetchingEmailHubPlan,
    errorFetchingPlan,
    isEmailHubRequired,
  } = useUpgradePlanContext();

  const { refetch: refetchPundit } = usePunditUserContext();
  const modal = useModal();

  const handleOnSuccess = async () => {
    await refetchPundit();

    void modal.hide();
    modal.remove();
    if (isEmailHubRequired) {
      // [TODO][EmailHubBilling][AfterRelease] Remove this and diagnose the actual issue
      window.location.reload();
      return;
    }
    if (onSuccess) {
      await onSuccess();
    }
  };

  const handleOnClose = async () => {
    await refetchPundit();

    if (onCloseModal) {
      await onCloseModal();
    }
    await modal.hide();
    modal.remove();
  };

  return (
    <Modal isOpen={modal.visible} onClose={handleOnClose}>
      <Modal.Overlay />
      <Modal.Content size="md" className="!max-h-[85vh] !w-[35.25rem]">
        {isPlanLoading || isEmailHubPlanLoading ? (
          <Loader title={t([i18nRoot, "loading.plan"])} />
        ) : errorFetchingPlan || errorFetchingEmailHubPlan ? (
          <ContactSupport
            title={t([i18nRoot, "errors.plan_not_found.title"])}
            errorMessage={t([i18nRoot, "errors.plan_not_found.message"])}
          />
        ) : (
          <UpgradeFlow
            subheading={subheading}
            successButtonLabel={successButtonLabel}
            handleOnSuccess={handleOnSuccess}
            modal={modal}
          />
        )}
      </Modal.Content>
    </Modal>
  );
};
